import React from 'react';
var defaultValue = {
  app: null
};
export default React.createContext(defaultValue);